import React, {Fragment, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Breadcrumb from '../../../../layout/breadcrumb'
import {Container, Row, Col, Card, CardHeader, CardBody, Form, Button} from "reactstrap";
import withReducer from "../../../../store/withReducer";
import productReducer from "../../../manage-product/store";
import * as yup from "yup";
import {
    createDuplicateProduct,
    getProduct,
    getProductCreateSettings,
    getProductSettings,
    setProduct,
    setProductSettings, setProductSubCategory, updateProduct, createSentImage,
    getSizeQuantity,
    setSizeConfigureQuantity,
    getProductPublications
} from "../../store/prodcutSlice";
import {
    getProductCreateSetting,
    sellerBrandSuggestionApi,
    taxonomySuggestionApi
} from "../../../../services/manage-product/productService";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import UserForm from "../../../manage-user/user/userForm";
import General from "./content/general";
import Composition from "./content/composition";
import ProductImage from "./content/productImage";
import Variation from "./content/variation";
import moment from "moment";
import {useHistory, useParams} from "react-router-dom";
import {updateUser} from "../../../manage-user/store/userSlice";
import ProductSeo from "./content/seo";
import Tiktok from "./content/tiktok";
import SalesChannels from "./content/salesChannels";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import PreLoader from "../../../../share-components/ui/preLoader";
import {mapSearchAutoSuggestion} from "../../../../utils/mapper";
import SweetAlert from "sweetalert2";
import AdditionalDetails from './content/additionalDetails';
import LogActivity from "../../../log";
import {toggleQuickPanel} from "../../../log/store/logSlice";
import { toast } from 'react-toastify';

const defaultValues = {
    id: '',
    brand: '',
    code: 3343,
    name: null,
    description: null,
    summary: null,
    measurements: '',
    product_type: '',
    product_category: '',
    product_sub_category: '',
    country: '',
    tag_type: '',
    season: '',
    taxonomy: '',
    tags: [],
    styles: [],
    custom_tags: [],
    available_in_length: [],
    available_in_fit: [],
    is_pre_order: false,
    pre_order_start_date: null,
    is_dispatch_date: false,
    no_of_days: null,
    dispatch_date: null,
    commodity_code: null,
    weight: null,
    unit_type: 2,
    compositions: [{}],
    selling_type: [],
    color: [],
    size_configuration: null,
    size: [],
    price: null,
    sale_price: null,
    cost_per_item_price: null,
    rrp: null,
    images: [],
    variation_configurations: [],
    meta_title: null,
    meta_description: null,
    shopify_product_id: null,
    is_personalisation: null,
    personalisation_text: null,
    buyer_instruction: null,
    fit_size_condition: [],
    fit_type: [],
    product_measurements: [],
    model_height: null,
    model_ware_size: null,
    is_holiday_mode: false,
    holiday_mode_start_date: null,
    holiday_end_date: '',
    bin_numbers: [],
    is_has_draft_product:false,
    is_third_party_seller:false,
    is_test : false,
    committed_quantity:[],
    available_in_looks: [],
    variant_mappings: [],
    variant_mapping_meta: {
        has_seller_link: false,
        unmapped_variant_ids: [],
        marketplace_variants_count: 0
    },
    skip_seller_variant_mapping: false,
    publish_to_all: false,
};

/**
 * Form Validation Schema
 */
yup.addMethod(yup.mixed, "holidayModeRequired", function (errorMessage) {
    return this.test(`test-card-length`, errorMessage, function (value) {
        const {path, createError} = this;
        let isValid = true;
        if (this.parent.is_holiday_mode) {
            isValid = value ? true : false;
        }
        return (
            (isValid) ||
            createError({path, message: errorMessage})
        );
    });
});
yup.addMethod(yup.array, "colourTag", function (errorMessage) {
    return this.test(`test-card-length`, errorMessage, function (value) {
        const {path, createError} = this;
        let isValidTag = true;
        let isValidColour = false;
        value.map((item, index) => {
            if (item.name) {
                isValidColour = true;
                if (!item.tag_name) {
                    isValidTag = false;
                }
            }
        });
        return (
            (isValidTag && isValidColour) ||
            createError({path, message: errorMessage})
        );
    });
});
yup.addMethod(yup.array, "packRatio", function (errorMessage) {
    return this.test(`test-card-length`, errorMessage, function (value) {
        const {path, createError} = this;
        let isValid = true
        const sellingType = this.parent.selling_type.map(function (item) {
            return item.id
        })
        if (sellingType.includes(2)) {
            value.map((item, index) => {
                if (item.ratio < 1) {
                    isValid = false;
                }
            });
        }
        return (
            (isValid) ||
            createError({path, message: errorMessage})
        );
    });
});

const schema = yup.object().shape({
    brand: yup.object().shape({id: yup.string(),}).nullable().required('You must select a brand.'),
    name: yup.string().required('You must enter Product Name'),
    code: yup.string().required('You must enter style/sku code'),
    tag_type: yup.object().shape({id: yup.string(),}).nullable().required('You must select a  Tag type.'),
    product_type: yup.object().shape({id: yup.string(),}).nullable().required('You must select a  type.'),
    product_category: yup.object().shape({id: yup.string(),}).nullable().required('You must select a category.'),
    product_sub_category: yup.object().shape({id: yup.string(),}).nullable().required('You must select a sub category.'),
    country: yup.object().shape({id: yup.string(),}).nullable().required('You must select a  country.'),
    season: yup.object().shape({id: yup.string(),}).nullable().required('You must select a season.'),
    price: yup.number().transform(value => (isNaN(value) ? undefined : value)).required('You must enter price'),
    // ASSUMPTION: same rule as hs_code below — weight feeds the carrier customs declaration, so it is
    // mandatory (and non-zero) for Goddiva's own products and stays optional for third-party sellers.
    weight: yup.number().when('$is_third_party_seller', (is_third_party_seller) => {
        if (!is_third_party_seller) {
            return yup.number()
                .transform(value => (isNaN(value) ? undefined : value))
                .typeError('Weight should be a number')
                .required('You must enter weight')
                .moreThan(0, 'Weight must be greater than 0');
        }
        return yup.number().transform(value => (isNaN(value) ? undefined : value)).nullable();
    }),
    hs_code: yup.number().when('$is_third_party_seller', (is_third_party_seller) => {
        if(!is_third_party_seller){
            return yup.number().required("HS code is a required field").transform(value => (isNaN(value) ? undefined : value)).typeError('should be a number').test(
                "len",
                "can be empty or should be greater than 5",
                (val) => {
                    if (val === undefined) {
                        return true;
                    }
                    return val.toString().length === 0 || (val.toString().length >= 6);
                }
            )
        }else{
            return yup.number().nullable()
        }
    }),
    // sale_price: yup.number().transform(value => (isNaN(value) ? undefined : value)).required('You must enter sale price').moreThan(yup.ref('cost_per_item_price'), "sale price should be grater than  cost price"),
    cost_per_item_price: yup.number().transform(value => (isNaN(value) ? undefined : value))
        .required('You must enter cost price')
        .when('$is_third_party_seller', {
            is: false,
            then: yup.number().transform(value => (isNaN(value) ? undefined : value)).moreThan(0, 'Cost price must be greater than 0'),            
        }),
    color: yup.array().min(1, "you must select a colour"),
    size: yup.array().packRatio('you must fill all size ratio'),
    selling_type: yup.array().min(1, "you must select a selling type"),
    size_configuration: yup.object().shape({id: yup.string(),}).nullable().required('You must select a size Configuration'),
    holiday_end_date: yup.mixed().holidayModeRequired('you must enter Holiday Mode'),
    product_measurements: yup.array().of(
        yup.object().shape({
            value: yup.number()
                .typeError('Measurement value must be a number')
                .min(0, 'Measurement value must be ≥ 0')
                .nullable()
                .transform((v, o) => (o === '' || o === null || o === undefined) ? null : v),
        })
    ).nullable(),
});

const dataMenu = [
    {
        type: 1,
        text: 'Products',
        link: '/product'
    },
    {
        type: 0,
        text: "Edit Product"
    }
];

const EditProduct = () => {
    const {id} = useParams();
    const dispatch = useDispatch();
    let history = useHistory();
    const [loading, setLoading] = useState(true);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [isButtonVisible, setIsButtonVisible] = useState(false);

    const productState = useSelector(({product}) => product.product.productSettings);
    const productStates = useSelector(({product}) => product.product);
    const channelPublicationsState = useSelector(({product}) => product.product.channelPublications);
    const [isThirdPartySeller, setIsThirdPartySeller] = useState(false);
    // null = no channel has been ticked/unticked in the Sales channels card yet (no explicit selection).
    // An array (even empty) means the user has seen and can edit the current channel selection.
    const [selectedPublications, setSelectedPublications] = useState(null);
    const currentUser = useSelector(({authReducer}) => authReducer.data.user);
    const {handleSubmit, formState, reset, control, register, setValue, trigger, getValues, watch} = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema),
        context: { is_third_party_seller: isThirdPartySeller }
    });
    const {errors, isDirty} = formState;

    // Mystery tag should be exact "mystery" (not contains)
    const hasMysteryTag = watch('tags').some(item => 
        item.name.toLowerCase().includes('mystery')
    );

    // Pick mystery_X dynamically (mystery_1 ... mystery_10)
    const mysteryTagValue = watch('tags').find(item =>
    /^mystery_(\d{1,2})$/i.test(item?.name || '')
    )?.name;

    const hasLooklabMain = watch('tags').some(item => item.name === 'looklab_main' || item.name === 'Looklab_main')
    useEffect(() => {
        if (id) {
            // history.goBack();
            window.scrollTo(0, 0)
            dispatch(getProductCreateSettings({id: id})).then(res => {
                if (!res.error) {
                    dispatch(setProductSettings(res.payload))
                    dispatch(getProduct(id)).then(res => {
                        if (!res.error) {
                            dispatch(setProductSubCategory(res.payload.sub_categories))
                            reset(res.payload.product);
                            // A never-published product defaults to "Publish to all channels" ticked so the
                            // first Save & Publish lands it on every sales channel. Published products keep
                            // their stored value.
                            if (!res.payload.product?.shopify_product_id) {
                                setValue('publish_to_all', true);
                            }
                            // Fetch the real, currently-published channels up front so the Sales channels card
                            // already reflects Shopify's actual state without the user having to open it —
                            // otherwise an untouched picker looks like "no selection" and wrongly triggers
                            // the unpublish-all confirmation even when nothing would actually change.
                            if (res.payload.product?.shopify_product_id) {
                                dispatch(getProductPublications(id));
                            }
                            // Grams is the default unit: only a product that already has a weight keeps its saved unit.
                            if (!(parseFloat(res.payload.product?.weight) > 0)) {
                                setValue('unit_type', 2);
                            }
                            setValue(
                                "skip_seller_variant_mapping",
                                !!res.payload.product?.skip_seller_variant_mapping
                            );
                            setIsThirdPartySeller(getValues('is_third_party_seller'))
                            setLoading(false);
                            setTimeout(function () {
                                setIsButtonVisible(true);
                            }, 2000)
                        }
                    });
                }
                ;
            });
            dispatch(toggleQuickPanel({isOpen:false}))
        }


    }, [dispatch, id]);

    useEffect(() => {
        const sizeConfigure = getValues('size_configuration');
        if(sizeConfigure && hasMysteryTag){
            // If mystery tag exists but mystery_X not selected → toast error + don't call API
                if (!mysteryTagValue) {
                toast.error("Please add a mystery_X tag (mystery_1 to mystery_10).", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            }

            const data ={
                "size_matrix_configurations" : sizeConfigure?.id,
                tag: mysteryTagValue,
            }
            dispatch(getSizeQuantity(data)).then(res => {
                dispatch(setSizeConfigureQuantity(res.payload))
            })
        }
    },[getValues('size_configuration'), hasMysteryTag, mysteryTagValue])


    useEffect(() => {
        if (!hasLooklabMain) {
            setValue('looklab_products',[])
        }
    },[hasLooklabMain])

    // Pre-select the currently published channels the first time the picker's data arrives.
    // Left alone afterwards so it doesn't clobber edits the user makes in the multi-select.
    useEffect(() => {
        if (channelPublicationsState?.data && selectedPublications === null) {
            const {publications = [], published_gids = []} = channelPublicationsState.data;
            setSelectedPublications(publications.filter(p => published_gids.includes(p.gid)));
        }
    }, [channelPublicationsState?.data]);

    const onFormSubmit = (data) => {
        const buttonType = window.event.submitter.value
        data.isPublish = buttonType;

        // Check for negative inventory values
        let hasNegativeInventory = false;
        
        // Check variation configurations (size quantities)
        if (data.variation_configurations && data.variation_configurations.length > 0) {
            data.variation_configurations.forEach((variation) => {
                if (variation.variations && variation.variations.length > 0) {
                    variation.variations.forEach((subVariation) => {
                        if (getValues('size') && getValues('size').length > 0) {
                            getValues('size').forEach((sizeItem) => {
                                const qty = subVariation[sizeItem.id];
                                if (qty !== null && qty !== undefined && qty !== '' && Number(qty) < 0) {
                                    hasNegativeInventory = true;
                                }
                            });
                        }
                    });
                }
                // Check pack_for_single
                if (variation.pack_for_single !== null && variation.pack_for_single !== undefined && variation.pack_for_single !== '' && Number(variation.pack_for_single) < 0) {
                    hasNegativeInventory = true;
                }
            });
        }
        
        // Check color array for pack_for_single
        if (data.color && data.color.length > 0) {
            data.color.forEach((colorItem) => {
                if (colorItem.pack_for_single !== null && colorItem.pack_for_single !== undefined && colorItem.pack_for_single !== '' && Number(colorItem.pack_for_single) < 0) {
                    hasNegativeInventory = true;
                }
            });
        }
        
        if (hasNegativeInventory) {
            toast.error("Cannot save product with negative inventory quantities.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        // Every Save & Publish with "Publish to all channels" unticked gets a confirm. The message
        // depends on what will actually happen: a never-published product is created on no channel,
        // a published product with a channel selection keeps only those channels, and a published
        // product with no selection is removed from every channel (confirm_unpublish_all).
        if (data.isPublish === "1" && !data.publish_to_all) {
            const isPublished = !!getValues('shopify_product_id');
            const hasExplicitPublicationSelection = selectedPublications !== null;
            let title;
            if (!isPublished) {
                title = 'You have not ticked "Publish to all channels". This product will be created on Shopify but will NOT be visible on the storefront or any sales channel. Do you want to continue?';
            } else if (hasExplicitPublicationSelection) {
                title = selectedPublications.length > 0
                    ? `You have not ticked "Publish to all channels". This product will only be available on the ${selectedPublications.length} sales channel(s) ticked under Sales channels and removed from all others. Do you want to continue?`
                    : 'You have not ticked "Publish to all channels" and no channel is ticked under Sales channels. This product will be removed from every sales channel and will no longer appear on the storefront. Do you want to continue?';
            } else {
                title = 'You have not ticked "Publish to all channels". This product will be removed from all sales channels and will no longer appear on the storefront. Do you want to continue?';
            }
            SweetAlert.fire({
                title: title,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, continue',
                cancelButtonText: 'No, go back',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    if (isPublished && !hasExplicitPublicationSelection) {
                        data.confirm_unpublish_all = true;
                    }
                    continueFormSubmit(data);
                }
            });
            return;
        }

        continueFormSubmit(data);
    }

    const continueFormSubmit = (data) => {
        if(!isThirdPartySeller){
            const tenPercentValue = data.cost_per_item_price + (data.cost_per_item_price * 10)/100;
            const isPriceInvalid = data.price < tenPercentValue;
            const isSalePriceInvalid = data.sale_price !== null && data.sale_price !== '' && data.sale_price < tenPercentValue;

            if(isSalePriceInvalid){
                // return toast.error(`The Sale Price must not be less than 110% (£${tenPercentValue.toFixed(2)}) of the Cost Price (e.g., £${tenPercentValue.toFixed(2)}).`, {
                //     position: toast.POSITION.TOP_RIGHT,
                //   });
                onConfirmCostPreItem(data, `The sale price must be at least 10% extra than the cost price, Do you still want to continue?`);
            }else if(isPriceInvalid) {
                // return toast.error(`The Price must not be less than 110% (£${tenPercentValue.toFixed(2)}) of the Cost Price .`, {
                //     position: toast.POSITION.TOP_RIGHT,
                //   });
                onConfirmCostPreItem(data, `The price must be at least 10% extra than the cost price, Do you still want to continue?`);
            }else {
                onSubmit(data);
            }
        }else{
            // block Save + Save&Publish if mapping required but not complete
            const meta = getValues("variant_mapping_meta");
            const statusId = getValues("status_id"); // assumed in payload from backend reset()

            const mappingRequired =
            meta?.has_seller_link === true && Number(statusId) !== 1;

            const isMappingComplete =
            mappingRequired ? (meta?.unmapped_variant_ids || []).length === 0 : true;

            if (!isMappingComplete) {
                toast.error("Please complete variant mapping before saving/publishing.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            }


            onSubmit(data);
        }
    }

    const onSubmit = (data) => {
        data.brand = data.brand.id;
        data.country = data.country.id;
        data.product_type = data.product_type.id;
        data.product_category = data.product_category.id;
        data.product_sub_category = data.product_sub_category.id;
        data.taxonomy = data.taxonomy ? data.taxonomy.id : "";
        data.tag_type = data.tag_type.id;
        data.model_ware_size = data.model_ware_size.id;
        if (data.size_configuration) {
            data.size_configuration = data.size_configuration.id;
        }
        if (data.commodity) {
            data.commodity = data.commodity.id;
        }
        if(!hasLooklabMain){
            data.looklab_products = []
        }
        data.season = data.season.id;
        let tags = [];
        (data.tags).map((item, i) => {
            tags.push(item.id);
        });
        data.tags = tags;
        let styles = [];
        (data.styles).map((item, i) => {
            styles.push(item.id)
        });
        data.styles = styles;
        data.dispatch_date = data.dispatch_date ? moment(data.dispatch_date).format('YYYY-MM-DD') : null;
        data.pre_order_start_date = data.is_pre_order ? (data.is_dispatch_date || data.no_of_days) && !data.pre_order_start_date  ?  moment().format('YYYY-MM-DD') : data.pre_order_start_date : null;
        data.holiday_mode_start_date = data.is_holiday_mode ? data.holiday_end_date && !data.holiday_mode_start_date ? moment().format('YYYY-MM-DD') :  data.holiday_mode_start_date : null ;
        data.holiday_end_date = data.holiday_end_date ? moment(data.holiday_end_date).format('YYYY-MM-DD') : null;

        let selling_type = [];
        (data.selling_type).map((item, i) => {
            selling_type.push(item.id)
        });
        data.selling_type = selling_type;

        let colors = [];
        (data.color).map((item, i) => {
            if (item.id) {
                colors.push({
                    colour_id: item.id,
                    tag_name: item.tag_name,
                    product_image_id: item.product_image_id,
                    pack_for_single: item.pack_for_single,
                    making_video_url: item.making_video
                });
            }
        });
        data.color = colors;

        let size = [];
        (data.size).map((item, i) => {
            size.push({
                size_matrix_id: item.id,
                ratio: (data.selling_type.length > 1 || (data.selling_type).includes(2)) ? item.ratio : 0
            })
        });
        data.size = size;

        let composition = [];
        (data.compositions).map((item, i) => {
            if (item.composition_id) {
                composition.push({composition_id: Number(item.composition_id), percentage: item.percentage});
            }
        });
        let fit_type = [];
        (data.fit_type).map((item, i) => {
            fit_type.push(item.id)
        });
        data.fit_type = fit_type;

        let fit_size_condition = [];
        (data.fit_size_condition).map((item, i) => {
            fit_size_condition.push(item.id)
        });
        data.fit_size_condition = fit_size_condition;
        data.product_measurements = (data.product_measurements || []).map(row => ({
            measurement_type_id: row.measurement_type_id,
            unit: row.unit,
            value: row.value,
        }));
        data.compositions = composition;

        data.available_in_fit = (data.available_in_fit || []).map(item => item.name);
        data.available_in_length = (data.available_in_length || []).map(item => item.name);

        if(data.isPublish === "1" && data.name.includes("[RENAME TITLE]")){
            toast.error("You can't include 'RENAME TITLE' in the title. Please provide a proper title.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        // Only send a selection when the Sales channels checkboxes have actually been used —
        // otherwise leave publication_gids out so the backend's default/confirm flow applies.
        if (selectedPublications !== null) {
            data.publication_gids = selectedPublications.map(item => item.gid);
        }

        setButtonDisable(true);
        dispatch(updateProduct({...data})).then(res => {
            setButtonDisable(false);
            console.log('updateProduct dispatch part');
            console.log(res);
            const p = res?.payload;

            // handle mapping-required response
            if (p?.__variant_mapping_required === true || p?.code === "VARIANT_MAPPING_REQUIRED") {
                if (typeof p.status_id !== "undefined") setValue("status_id", p.status_id);
                if (typeof p.has_seller_link !== "undefined") setValue("has_seller_link", p.has_seller_link);
                if (typeof p.requires_variant_mapping !== "undefined") setValue("requires_variant_mapping", p.requires_variant_mapping);

                // store unmapped ids so your save-blocking logic works
                if (Array.isArray(p.unmapped_variant_ids)) {
                setValue("variant_mapping_meta", {
                    ...(getValues("variant_mapping_meta") || {}),
                    has_seller_link: true,
                    unmapped_variant_ids: p.unmapped_variant_ids,
                });
                }

                toast.error(p.message, { position: toast.POSITION.TOP_RIGHT });
                
                // SCROLL TO VARIATION SECTION
                setTimeout(() => {
                    const el = document.getElementById("variation-section");
                    if (el) {
                        const yOffset = -120; // 🔹 adjust if needed (header height)
                        const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: y,
                            behavior: "smooth",
                        });
                    }
                }, 100);

                return;
            }


            if (!res.error) {
                history.push({
                    pathname: '/product',
                    state: {from: "submit"}
                })
            }
        });
    }

    const onConfirmCostPreItem = (data, message) => {
        SweetAlert.fire({
            title: 'Confirm!',
            text: message ?? "The Cost per item price is greater than the selling price. Do you want to continue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then((result) => {
            if(result.value) {
                onSubmit(data);
            }
        });
    }

    const onConfirmDuplicate = (row) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "Do you want to create duplicate product?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Create',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        })
            .then((result) => {
                if (result.value) {
                    dispatch(createDuplicateProduct({id})).then(res => {
                        setButtonDisable(false);
                        if (!res.error) {
                            history.push({
                                pathname: `/product/${res.payload}/edit`,
                            })
                        }
                    });
                }
            })
    }

    const onConfirmSendImage = (row) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "Do you want to Send Image",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Send',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        })
            .then((result) => {
                if (result.value) {
                    dispatch(createSentImage({id})).then(res => {
                        setButtonDisable(false);
                        if (!res.error) {

                        }
                    });
                }
            })
    }

    return (
        <Fragment>

            <Container fluid={true}>
                {loading ? <>
                    <PreLoader></PreLoader>
                </> : <Row>
                    <Breadcrumb title={getValues('name')} data={dataMenu}/>

                    {(currentUser.modules).includes('create-duplicate') && !isThirdPartySeller && <Col sm="12">
                        <Button onClick={onConfirmDuplicate} className="pull-right  font-weight-bold" color="success"
                                type="button">Generate Duplicate
                        </Button>
                    </Col>}

                    <div style={{position: 'fixed', top: '50%', zIndex: 10,right:0}}>
                        <LogActivity log="product" id={id}></LogActivity>
                    </div>

                    <AdditionalDetails productStates={productStates}/>

                    <Col sm="12">
                        <Form className="needs-validation" noValidate="" onSubmit={handleSubmit(onFormSubmit)}>
                            <General control={control} errors={errors} register={register} setValue={setValue}
                                     currentUser={currentUser}
                                     trigger={trigger} productState={productState} getValues={getValues}
                                     productStates={productStates} hasLooklabMain={hasLooklabMain} watch={watch}></General>
                            <Composition control={control} errors={errors} register={register} setValue={setValue}
                                         trigger={trigger} productState={productState}
                                         getValues={getValues}></Composition>
                            <ProductImage productState={productState} setValue={setValue} getValues={getValues}
                                          onConfirmSendImage={onConfirmSendImage} currentUser={currentUser}
                                          trigger={trigger}></ProductImage>
                            <div style={{marginBottom: 180}}>
                                <div id="variation-section">
                                    <Variation control={control} errors={errors} register={register} setValue={setValue}
                                           setIsButtonVisible={setIsButtonVisible} productStates={productStates} currentUser={currentUser}
                                           trigger={trigger} productState={productState} modules={currentUser.modules}
                                           getValues={getValues} watch={watch} hasMysteryTag={hasMysteryTag}></Variation>
                                </div>
                                <ProductSeo control={control} errors={errors} register={register} setValue={setValue}
                                            trigger={trigger} getValues={getValues}></ProductSeo>
                                {!isThirdPartySeller && <Tiktok control={control} errors={errors} register={register} setValue={setValue}
                                            trigger={trigger} getValues={getValues}></Tiktok>}
                                <SalesChannels register={register} watch={watch}
                                               isPublished={!!getValues('shopify_product_id')}
                                               channelPublicationsState={channelPublicationsState}
                                               selectedPublications={selectedPublications}
                                               setSelectedPublications={setSelectedPublications}
                                               onRetry={() => dispatch(getProductPublications(id))}></SalesChannels>
                                
                            </div>
                            <div id="submit-div">
                                {isButtonVisible && <div className="w-100">
                                    <div style={{display: "flex", justifyContent: 'flex-end'}}>
                                        <Card style={{position: 'fixed', bottom: 35, zIndex: 9}}>
                                            <CardBody>
                                                <div className="form-row align-items-center">
                                                    <Col md={12}>
                                                        <div className="d-flex align-items-center justify-content-end" style={{gap: '16px'}}>
                                                            {!getValues('shopify_product_id') &&
                                                                <ButtonLoader color="success" value="0" className="mr-2"
                                                                              type="submit" disabled={buttonDisable}
                                                                              btntext="Save"></ButtonLoader>}
                                                            {((currentUser.permission).includes('Publish Product') || getValues('shopify_product_id')) &&
                                                                <ButtonLoader disabled={buttonDisable} color="primary"
                                                                              value="1"
                                                                              type="submit"
                                                                              btntext="Save & Publish"></ButtonLoader>}
                                                        </div>
                                                    </Col>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </div>}
                            </div>
                        </Form>
                    </Col>
                </Row>}
            </Container>


        </Fragment>
    );

}

export default withReducer([{product: productReducer}])(EditProduct);